/* ========================================================================
    Bootstrap
 ========================================================================== */
import axios from "axios";

// Axios settings
const token = document.head.querySelector<HTMLMetaElement>(
    'meta[name="csrf-token"]',
);
const appAxios = axios.create({
    headers: {
        "X-Requested-With": "XMLHttpRequest",
    },
    timeout: 30000,
});

if (token) {
    appAxios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
    console.error(
        "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token",
    );
}

export { appAxios };
